import React, { useState, useEffect } from "react";

const wrap = {
  position: "fixed",
  bottom: 18,
  right: 18,
  zIndex: 1000,
  background: "#14304a",
  color: "#fff",
  borderRadius: 10,
  padding: "12px 16px",
  boxShadow: "0 8px 24px rgba(0,0,0,.25)",
  display: "flex",
  alignItems: "center",
  gap: 12,
  fontSize: 14,
  maxWidth: 340,
};

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => window.localStorage.getItem("tios_install_dismissed") === "1"
  );

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => setDeferred(null);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferred || dismissed) return null;
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  if (standalone) return null;

  return (
    <div style={wrap} data-testid="install-app-banner">
      <span>Install PTO Tracker as a desktop app for one-click access.</span>
      <button
        data-testid="install-app-btn"
        style={{ background: "#0f5132", color: "#fff", border: "none", borderRadius: 8, padding: "8px 14px", cursor: "pointer", fontWeight: 700, whiteSpace: "nowrap" }}
        onClick={async () => {
          deferred.prompt();
          await deferred.userChoice;
          setDeferred(null);
        }}
      >
        Install
      </button>
      <button
        data-testid="install-dismiss-btn"
        aria-label="Dismiss"
        style={{ background: "transparent", color: "#cbd5e1", border: "none", cursor: "pointer", fontSize: 16, lineHeight: 1 }}
        onClick={() => {
          setDismissed(true);
          window.localStorage.setItem("tios_install_dismissed", "1");
        }}
      >
        ✕
      </button>
    </div>
  );
}
